module.exports = {
  langs: ['es', 'en'],
  defaultLangKey: 'es',
};
